import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('app.WalletsPage.KycPage.wizard.AdditionalDocumentsStep.Reasons', {
    inOrderToApprove:
        'In order to approve your application it is needed to (1) check you’re a real business; (2) understand your corporate structure; and (3) identify and verify who controls and owns your business.',
    providingDocuments:
        'Providing additional supporting documents can help to process your application in the case that it is not possible to find enough publicly available information to verify these things.',
    theseCanBeUseful: 'These documents can be helpful to prove you’re a real company:',
    balanceSheet: 'Balance sheet / P&L',
    annualStatement: 'Annual financial statement',
    articlesOrCertificate: 'Articles or certificate of incorporation/organisation/registration',
    theseCanHelp: 'These documents can help to understand who owns you:',
    corporateStructureChart: 'Corporate structure chart',
    shareholderRegister: 'Shareholder register',
    annualFinancialStatement: 'Annual financial statement',
    partnershipRegistration: 'Partnership registration confirmation',
    partnershipAgreement: 'Partnership agreement or certificate',
    charitiesRegisterExtract: 'Charities register extract, trust deed',
    trustDeed: 'Trust deed',
    operatingAgreement: 'Operating agreement',
    articlesOfIncorporation: 'Articles of incorporation',
    stockCertificate: 'Stock certificate',
    confirmationStatement: 'Confirmation statement',
    theseCanHelpToUnderstand:
        'These documents can help to understand who controls you (e.g. your directors, partners, managing members etc):',
    directorsRegister: 'Register of directors',
    financialStatement: 'Annual financial statement',
    partnershipRegistrationOrAgreement: 'Partnership registration confirmation or agreement',
    charitiesDocument: 'Charities register extract, trust deed',
    corporateResolution: 'Corporate resolution',
    accountAuthorization: 'Account authorization form',
    bylaws: 'Copy of by-laws',
});
